import React from 'react';
import { useWeather } from '../../context';
import { useAuth } from '../../hooks/useAuth';
import { Play, Trash2, Table, RefreshCw } from 'lucide-react';
import { SaveSearchButton } from './SaveSearchButton';

export function ActionButtons() {
  const { 
    fetchData, 
    clearData, 
    setShowPayoutTable,
    loading,
    modelSelect
  } = useWeather();
  const { credits } = useAuth();

  const isWildfire = modelSelect === 'wildfire';

  const handleRefresh = () => {
    if (isWildfire) {
      fetchData();
    }
  };

  return (
    <div className="space-y-3">
      <button
        onClick={fetchData}
        disabled={loading || credits <= 0}
        className="btn w-full flex items-center justify-center gap-2 disabled:opacity-50"
      >
        {loading ? (
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
        ) : (
          <>
            <Play className="w-4 h-4" />
            {credits > 0 ? `Fetch Data (${credits} credits left)` : 'No Credits Available'}
          </>
        )}
      </button>
      
      {isWildfire && (
        <button
          onClick={handleRefresh}
          disabled={loading}
          className="btn w-full flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
          Refresh Fires
        </button>
      )}

      <button
        onClick={clearData}
        className="btn btn-secondary w-full flex items-center justify-center gap-2"
      >
        <Trash2 className="w-4 h-4" />
        Clear
      </button>
      <SaveSearchButton />
      <button
        onClick={() => setShowPayoutTable(true)}
        className="btn w-full flex items-center justify-center gap-2"
        style={{ background: 'var(--success-color)' }}
      >
        <Table className="w-4 h-4" />
        Show Payout Table
      </button>
    </div>
  );
}